import React from 'react';
import { useHistory } from 'react-router-dom';
import { PageTitle } from '@cordata/buffet';
import { format } from 'date-fns';

import { UncontrolledTable } from '~/components/common';
import { getBadgeClass } from '~/components/SendgridEvent/Form';

import { useAdmin } from '~/utils/admin';

const defaultSorted = [{
  id: 'sentDate',
  desc: true,
}];

const columns = [{
  id: 'sentDate',
  Header: 'Sent Date',
  accessor: 'attributes.sentDate',
  Cell: c => (c.value ? format(c.value, 'ddd MMM Do YYYY [@] h:mm A') : 'N/A'),
}, {
  id: 'toEmailAddress',
  Header: 'To Email Address',
  accessor: 'attributes.toEmailAddress',
}, {
  id: 'subject',
  Header: 'Subject',
  accessor: 'attributes.subject',
}, {
  id: 'status',
  Header: 'Status',
  accessor: 'attributes.status',
  Cell: c => (
    <span className={`badge badge-${getBadgeClass(c.value)}`}>
      {c.value || 'unknown'}
    </span>
  ),
}];

const OutboundEmails = () => {
  const history = useHistory();
  const { org, div } = useAdmin();

  return (
    <>
      <PageTitle>
        Outbound Emails
      </PageTitle>

      {org &&
        <UncontrolledTable
          name="outbound-emails"
          defaultSorted={defaultSorted}
          endpoint={{
            url: 'admin/outbound_email',
            params: {
              'org-uid': org.id,
              ...(div && { 'division-uid': div.id }),
            },
          }}
          columns={columns}
          getTrProps={(state, rowInfo) => ({
            style: {
              cursor: 'pointer',
            },
            onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/admin/outbound-emails/${rowInfo.original.id}`)),
          })}
        />
      }
    </>
  );
};

OutboundEmails.propTypes = {};

export default OutboundEmails;
